module.exports = __webpack_public_path__ + "img/50.9eff9c9.jpg";